import Alert from './alert';

function alert(props) {
  return new Alert(props);
}

export default alert;


//////////////////
// WEBPACK FOOTER
// ./~/codeages-design/src/lib/alert/index.js
// module id = 543
// module chunks = 9